import PropTypes from 'prop-types';
import React from 'react';

const ReportDropDown = ({value, label, options, onChange}) => {
  return (
    <div className='editable-selectfield'>
      <div className='form-group'>
        <label>{label}</label>
        <select className='form-control' value={value} onChange={onChange}>
          {options.map(o => <option key={o.label} value={o.value}>{o.label}</option>)}
        </select>
      </div>
    </div>
  );
};

ReportDropDown.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
};

export default ReportDropDown;
